export default __webpack_public_path__ + "static/dark leaves-732b22dca25380ef3b8e9a7ba3aeac6b.png";